module.exports = __webpack_public_path__ + "../resources/img/ic_check_circle_line_primary.4ad9711b.svg";